<template>
  <div>
    <app-banner
      v-if="!$route.meta.public"
      :mastery-app="true"
    />
    <topbar v-if="!fullscreen" />
    <main
      class="router-view"
      :class="{
        header: $route.meta.header,
        footer: $route.meta.footer,
        fullscreen: $route.meta.fullscreen,
        noSidebar: hideSidebar,
        masteryFooter: $route.meta.masteryFooter,
        masteryHeader: $route.meta.masteryHeader,
      }"
    >
      <router-view />
    </main>
    <mastery-sidebar v-if="!hideSidebar && !fullscreen" />
    <template v-if="!fullscreen">
      <notify />
      <mastery-mobile-menu />
      <template v-if="user">
        <preferred-po-modal v-if="preferredPoEnabled" />
        <upsell-modal v-else />
        <catalog-modal />
        <base-upsell-modal />
        <modal-container />
        <sheets-container />
      </template>
    </template>
    <attachment-modal />
    <mira-drawer v-if="user" />
    <bsod />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import AppBanner from '@components/banners/app-banner.vue';
import BaseUpsellModal from '@/components/purchasing/base-upsell-modal.vue';
import CatalogModal from '@components/purchasing/catalog-modal.vue';
import MasteryMobileMenu from '@components/mastery/mobile-menu.vue';
import MasterySidebar from '@components/mastery/sidebar.vue';
import ModalContainer from '@components/modals/modal-container.vue';
import Notify from '@components/singletons/notify.vue';
import PreferredPoModal from '@components/purchasing/preferredPoModal.vue';
import Topbar from '@components/singletons/topbar.vue';
import UpsellModal from '@components/purchasing/upsell-modal.vue';
import bsod from '@/components/ui/bsod.vue';

import { asyncImport } from '@/utils';
const AttachmentModal = defineAsyncComponent(() => asyncImport(import('@components/attachments/attachment-modal')));
const MiraDrawer = defineAsyncComponent(() => asyncImport(import('@components/mira/MiraDrawer.vue')));

export default {
  components: {
    AppBanner,
    AttachmentModal,
    MiraDrawer,
    BaseUpsellModal,
    CatalogModal,
    MasteryMobileMenu,
    MasterySidebar,
    ModalContainer,
    Notify,
    PreferredPoModal,
    Topbar,
    UpsellModal,
    bsod,
  },
  computed: {
    fullscreen() {
      return this.$route.meta.fullscreen;
    },
    hideSidebar() {
      if (this.$route.meta.sidebar === 'hideUnlessAuthenticated' && !this.user) {
        return true;
      }
      return this.$route.meta.sidebar === 'hide';
    },
    preferredPoEnabled() {
      const classification = this.$store.getters['session/classification'];
      return classification && classification.preferredPurchaseOrderId;
    },
    user() {
      return this.$store.getters['session/currentUser'];
    },
  },
};
</script>

<style lang='scss' scoped>
.router-view {
  padding: rem-calc(48) 0 0 rem-calc(88);
  display: flex;
  flex-wrap: wrap;
  min-height: 100vh;
  box-sizing: border-box;

  > *:first-child {
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    padding: rem-calc(32);
  }

  &.header {
    > *:first-child {
      margin-top: rem-calc(109);
    }
  }

  &.masteryHeader {
    > *:first-child {
      margin-top: rem-calc(45);
    }
  }

  &.footer {
    > *:first-child {
      margin-bottom: rem-calc(72);
    }
  }

  &.masteryFooter {
    > *:first-child {
      margin-bottom: rem-calc(44);
    }
  }

  &.fullscreen {
    padding: 0;
  }

  &.noSidebar {
    margin-left: 0;
  }

  @include breakpoint(small) {
    padding: rem-calc(72) 0 0 0;

    > *:first-child {
      padding: rem-calc(32) rem-calc(16);
    }
  }
}
</style>
